import { Button, ToggleButtonGroup } from "@mui/joy";

function FilterBarToggle(props) {
  return (
    <ToggleButtonGroup>
      {props.options.map((option) => (
        <Button
          color="neutral"
          onClick={() => props.onChange(option)}
          sx={{
            backgroundColor: props.value === option ? "#dfe7ed" : "#ffffff",
          }}
          key={option}
        >
          {option}
        </Button>
      ))}
    </ToggleButtonGroup>
  );
}

export default FilterBarToggle;
